import React, { useCallback, useEffect, useState } from "react";
import ApptCalendar from "../../components/cards/appt-calendar";
import DataProvider from "../../services";
import apdc from "../../assets/images/rd.png";
import { Button, FloatButton } from "antd";
import Colors from "../../constants/Colors";
import { Link, useNavigate } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import CardLoader from "../../components/elements/card-loader";
import AppointmentCard from "../../components/cards/appointment-card";
import Empty from "../../components/elements/empty";
import moment from "moment";
import img from "../../assets/images/poweredbymtn.png";
import whatsapp from "../../assets/images/WhatsApp.png";
import kobi from "../../assets/images/KUUL TRANS ROUND.png";
import ChatButton from "../../components/cards/message-card/chatButton";
import ChatInterface from "../../components/sections/chatai";

declare global {
  interface Window {
    ebanqo_widget: any;
  }
}

export default function Appointments() {
  const navigate = useNavigate();
  const [date, setDate] = useState<Date>(new Date());
  const [filterDate, setFilterDate] = useState<Date>(new Date());
  const [data, setData] = useState<any[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);

  // const [totalPages, setTotalPages] = useState<number>(1);
  // eslint-disable-next-line
  const [currentPage, setCurrentPage] = useState<number>(1);
  // eslint-disable-next-line
  const [pageSize, setPageSize] = useState<number>(200);

  const getAllAppt = useCallback(
    async (params?: Date) => {
      setLoading(true);
      try {
        const results = await DataProvider.getAllAppointment(
          currentPage,
          pageSize
        );
        const filter = results.data.appointments.filter(
          (item: any) => item.date === moment(params).format("DD-MM-YYYY")
        );
        setData(filter);
        setLoading(false);
      } catch (error: any) {
        setLoading(false);
      }
    },
    [pageSize, currentPage]
  );

  useEffect(() => {
    if (date) {
      getAllAppt(date);
    }
  }, [date, getAllAppt]);

  return (
    <div className="min-h-screen bg-neutral-50">
      <header className="bg-white border-b border-neutral-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6">
          <h1 className="text-xl sm:text-2xl font-semibold text-neutral-900 tracking-tight">
            Talk to a doctor
          </h1>
          <p className="mt-1 text-sm text-neutral-600">
            Book e-consultations and view your appointments by date.
          </p>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-6 space-y-6">
      <div className="grid lg:grid-cols-2 grid-cols-1 gap-5 justify-center py-4 mb-4">
        <ApptCalendar
          setDate={setDate}
          date={date}
          filterDate={filterDate}
          setFilterDate={setFilterDate}
        />
        <div className="bg-[#06509E] w-full grid grid-cols-2 gap-0 justify-center rounded-lg shadow">
          <img src={apdc} alt="care" className="rounded-l-lg w-[100%] h-full" />
          <div className="text-white lg:pt-20 md:pt20 pt-10 lg:pl-3 md:pl-4 pl-3 items-center justify-center">
            <h4 className="md:text-xl text-sm font-semibold mb-2">
              Appointment | E-Consultation
            </h4>
            <p className="font-semibold md:text-sm text-xs">
              Book an e-consultation to speak with a doctor
            </p>
            <div className="md:hidden block my-4">
              <Button
                size="small"
                className="text-xs"
                onClick={() => navigate("/main/appointments/booking")}
                style={{ backgroundColor: Colors.white }}
              >
                Book Appointment
              </Button>
            </div>
            <div className="my-4 md:block hidden">
              <Button
                onClick={() => navigate("/main/appointments/booking")}
                style={{ backgroundColor: Colors.white }}
              >
                Book Appointment
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full my-4">
        <div className="bg-white border border-solid border-gray-200 rounded-lg min-h-[65vh] w-full flex flex-col justify-start p-2">
          <div className="p-4 mb-4">
            {/* <h3 className="font-semibold text-lg">Upcoming Consultations</h3> */}
            <p className="text-gray-600 text-sm mt-1">
              This section shows your upcoming consultations. Select a date on
              the calendar to view appointments for that day. Each card displays
              the doctor's name, time, and date. If no consultations are found,
              you can refresh or book a new appointment.
            </p>
          </div>

          <div className="w-full flex justify-between items-center py-2 px-2">
            <h4>Appointments By Date</h4>
            <Link
              to="/main/appointments/all"
              className="flex text-sm items-center text-[#06509E]"
            >
              <h4>View all</h4> <FaChevronRight className="ml-1" />
            </Link>
          </div>

          <div className="w-full">
            {loading ? (
              <div className="flex md:justify-start justify-center flex-wrap">
                {[1, 2, 3, 4, 5].map((v, idx) => (
                  <CardLoader key={idx} />
                ))}
              </div>
            ) : !loading && data && data.length > 0 ? (
              <div className="">
                <div className="flex md:justify-start justify-center flex-wrap">
                  {[...data].reverse().map((v: any) => (
                    <AppointmentCard data={v} key={v.id} />
                  ))}
                </div>
              </div>
            ) : (
              <div className="">
                <Empty
                  imageStyle="md:h-44 h-24"
                  titleStyle="md:text-lg text-sm"
                  desStyle="md:text-base"
                  title="Empty"
                  buttons={[
                    {
                      name: "Refresh",
                      event: () => getAllAppt(date),
                    },
                  ]}
                  description={`No appointments available on ${moment(
                    date
                  ).format("Do MMMM YYYY")}`}
                />
              </div>
            )}
          </div>

          <div className="flex justify-center">
            <img src={img} alt="care" className="md:h-20 h-10 rounded-l-lg" />
          </div>
        </div>
      </div>
      </main>

      <ChatButton />

      {isChatOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[10000]">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6 relative">
            <button
              onClick={() => setIsChatOpen(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            >
              ✖
            </button>
            <ChatInterface />
          </div>
        </div>
      )}

      <div className="fixed bottom-10 -right-2 z-[9999] transform scale-150 flex items-center ">
        <FloatButton.Group
          trigger="click"
          type="default"
          style={{ insetInlineEnd: 24 }}
          icon={
            <img
              src={whatsapp}
              alt="WhatsApp"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          }
        >
          <FloatButton
            icon={
              <img
                src={whatsapp}
                alt="WhatsApp"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            }
            onClick={() =>
              window.open(
                "https://wa.me/233555061412?text=Hello%20Medpharma%20Team%2C%20I%20need%20assistance",
                "_blank",
                "noopener,noreferrer"
              )
            }
          />
          <FloatButton
            icon={<img src={kobi} alt="kobikull" />}
            // description="Ask Kobikuul, your health bot"

            onClick={() => setIsChatOpen(true)}
          />
        </FloatButton.Group>
      </div>
    </div>
  );
}
